import Draggable from 'react-draggable'
import Paper from '@material-ui/core/Paper'
import React from 'react'

export const PopoverDraggable = ({ position, open, children }) => {
  return (
    <Draggable>
      <Paper>{children}</Paper>
    </Draggable>
  )
}
